/* EditableTextControlComponent.js */

"use strict";

const InputBaseControlTextfieldComponent = require('@gluenetworks/input_base_control').Textfield;
const Renderer = require("./EditableTextControlRenderer");
const _ = require("lodash");

class EditableTextControlComponent extends InputBaseControlTextfieldComponent {

    /**
     * @schema.name Editable Text Control
     * @schema.package @gluenetworks/editable_text_control
     * @schema.namespace require("@gluenetworks/steve_ui_core").Control.Textfield.EditableText
     * @schema.events ["Disabled", "Placeholder", "Value", "Visible", "Invalid", "DarkTheme", "Focus", "Blur", "SetAttribute", "UserValue", "UserFocus", "UserBlur", "UserKeyDown"]
     *
     * @schema.configuration.editing.name editing
     * @schema.configuration.editing.type boolean
     * @schema.configuration.editing.default false
     * @schema.configuration.editing.required false
     *
     * @schema.configuration.placeholder.name placeholder
     * @schema.configuration.placeholder.type string
     * @schema.configuration.placeholder.default "Click to Edit"
     * @schema.configuration.placeholder.required false
     *
     */

    constructor(configOptions) {
        super(configOptions);

        this._editing = _.get(configOptions, 'editing', false);
        this._DEFAULT_PLACEHOLDER = 'Click to Edit';
        this._placeholder = _.get(configOptions, 'placeholder', this._DEFAULT_PLACEHOLDER);

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners(){

    }
    _unregisterListeners(){

    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    shutdown(){
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._editing = undefined;
        this._disabled = undefined;
        this._invalid = undefined;
        this._visible = undefined;
        this._value = undefined;
        this._darkTheme = undefined;
        this._placeholder = undefined;
        this._DEFAULT_PLACEHOLDER = undefined;
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    
    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /**
     * @schema.methods.setEditing.name setEditing
     * @schema.methods.setEditing.description Sets the editing state of the control and returns an instance of the control for chainability
     * @schema.methods.setEditing.returns Instance of the control
     * @schema.methods.setEditing.parameters.newVal.name newVal
     * @schema.methods.setEditing.parameters.newVal.description The editing state of the control
     * @schema.methods.setEditing.parameters.newVal.type boolean
     */
    setEditing(newBoolean){
        this._editing = newBoolean;
        this.emit('Editing', this._editing);
        return this;
    }
    /**
     * @schema.methods.isEditing.name isEditing
     * @schema.methods.isEditing.description Returns the editing state of the control
     * @schema.methods.isEditing.returns boolean
     */
    isEditing(){
        return this._editing;
    }
    get editing(){
        return this.isEditing();
    }
    set editing(newBoolean){
        return this.setEditing(newBoolean);
    }

    /**
     * @schema.methods.select.name select
     * @schema.methods.select.description Trigger a full text selection
     * @schema.methods.select.returns boolean
     */
    select(){
        this.emit('Select');
        return this;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = EditableTextControlComponent;